import styled from 'styled-components';

interface TableProps {
  columns?: string;
}

export const TableContainer = styled.div`
  overflow-x: auto;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
`;

export const TableHeader = styled.div<TableProps>`
  display: grid;
  grid-template-columns: ${props => props.columns || 'repeat(auto-fit, minmax(100px, 1fr))'};
  gap: 0.5rem;
  padding: 1rem;
  background: #f8f9fa;
  border-bottom: 2px solid #e9ecef;
  font-weight: 600;
  color: #495057;
  font-size: 0.875rem;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  text-align: left;
  
  > div {
    text-align: left;
  }
`;

export const TableBody = styled.div`
  background: white;
  overflow: hidden;
`;

export const TableRow = styled.div<TableProps>`
  display: grid;
  grid-template-columns: ${props => props.columns || 'repeat(auto-fit, minmax(100px, 1fr))'};
  gap: 0.5rem;
  padding: 1rem;
  border-bottom: 1px solid #e9ecef;
  cursor: pointer;
  transition: all 0.2s ease;
  align-items: center;

  &:hover {
    background: #f8f9fa;
  }

  &:last-child {
    border-bottom: none;
  }
`;

export const TableCell = styled.div`
  color: #64748b;
  font-size: 0.875rem;
  text-align: left;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  position: relative;
  
  &:hover::after {
    content: attr(title);
    position: absolute;
    bottom: 100%;
    left: 0;
    background: #1f2937;
    color: white;
    padding: 8px 12px;
    border-radius: 6px;
    font-size: 0.75rem;
    white-space: normal;
    z-index: 1000;
    max-width: 300px;
    word-wrap: break-word;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    display: ${props => props.title && props.title.length > 20 ? 'block' : 'none'};
  }
  
  &:hover::before {
    content: '';
    position: absolute;
    bottom: 100%;
    left: 10px;
    margin-bottom: -5px;
    border: 5px solid transparent;
    border-top-color: #1f2937;
    z-index: 1001;
    display: ${props => props.title && props.title.length > 20 ? 'block' : 'none'};
  }
`;

export const ClickableCell = styled(TableCell)`
  color: #667eea;
  cursor: pointer;
  text-decoration: none;
  transition: color 0.2s ease;

  &:hover {
    color: #5a67d8;
    text-decoration: underline;
  }
`;

// Specialized table components for search/modal contexts
export const SearchTable = styled.div`
  max-height: 400px;
  overflow-y: auto;
  margin: 0 1.5rem;
`;

export const SearchTableHeader = styled.div`
  display: grid;
  grid-template-columns: 1fr auto;
  gap: 1rem;
  padding: 12px 16px;
  background: #f9fafb;
  border-bottom: 1px solid #e5e7eb;
  font-weight: 600;
  color: #374151;
  font-size: 0.875rem;
  position: sticky;
  top: 0;
`;

export const SearchTableRow = styled.div`
  display: grid;
  grid-template-columns: 1fr auto;
  gap: 1rem;
  padding: 12px 16px;
  border-bottom: 1px solid #f3f4f6;
  transition: background-color 0.2s ease;

  &:hover {
    background: #f9fafb;
  }

  &:last-child {
    border-bottom: none;
  }
`;

export const SearchTableCell = styled.div`
  display: flex;
  align-items: center;
`;

export const SearchTableSubtext = styled.div`
  font-size: 0.75rem;
  color: #6b7280;
  margin-top: 2px;
`;